<template>
  <div class="text-xs md:text-header-window">
    <div class="flex w-full text-xxs md:text-xs items-center justify-center md:justify-start ml-px flex-wrap gap-4 md:min-w-80 md:ml-1">
      <div class="flex flex-col items-center flex-wrap">
        <img src="/img/icons/projects/tools/web.svg" :alt="$t('common.icon') + ' web'" class="w-9 h-9" />
        <p class="font-bold">Web</p>
      </div>
      <div class="flex flex-col items-center flex-wrap">
        <img src="/img/icons/projects/tools/figma.svg" :alt="$t('common.icon') + ' figma'" class="w-9 h-9" />
        <p class="font-bold mt-px">Figma</p>
      </div>
    </div>
    <h3 class="mt-5 mb-2">{{ $t('common.context') }}</h3>
    <p>
      {{ $t('project.vcip2025.contextFirstParagraph') }}
    </p>
    <br />
    <p>
      {{ $t('project.vcip2025.contextSecondParagraph') }}
    </p>
    <h3 class="mt-5 mb-2">{{ $t('common.tasksDone') }}</h3>
    <ul class="list-disc ml-3">
      <li>{{ $t('project.vcip2025.serviceLogo') }}</li>
      <li>{{ $t('project.vcip2025.serviceUIDesign') }}</li>
      <li>{{ $t('project.vcip2025.serviceImplementation') }}</li>
    </ul>
  </div>
</template>

<script setup>
</script>

